import createHistory from 'history/createBrowserHistory'
import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { persistReducer, persistStore } from 'redux-persist'
import createTransform from 'redux-persist/lib/createTransform'
import createEncryptor from 'redux-persist-transform-encrypt'
import storage from 'redux-persist/lib/storage'
import sanitizeAuthState from './reducers/sanitizeAuthState'
import * as persistActionCreators from './actions/PersistAction'
import middlewares from './reducers/middlewares'
import rootReducer from './reducers/RootReducer'
export const history = createHistory()

const encryptor = createEncryptor({
  secretKey: 'Quam Fusce Commodo Pellentesque',
  onError: function(error) {
    throw error
  },
})

// Drop half-broken sessions (logged in, but without an access token) on the way in
// and on the way out of storage. Outbound transforms run in reverse order, so this
// one receives state the encryptor has already decrypted. Keep it before the
// encryptor for that reason.
const authStateSanitizer = createTransform(sanitizeAuthState, sanitizeAuthState, {
  whitelist: ['AuthReducer'],
})

const persistConfig = {
  key: 'intake',
  whitelist: ['AuthReducer'],
  transforms: [authStateSanitizer, encryptor],
  storage,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(...middlewares)))

export const persistor = persistStore(store, () => store.dispatch(persistActionCreators.update({ isHydrated: true })))

export default store



// WEBPACK FOOTER //
// ./src/Store.js